import axiosInstance from "../../../helpers/api";

export const getAllBuckets = (body) => {
  return axiosInstance.get("/superadmin/question-buckets", body);
};

export const editBuckets = (formData) => {
  return axiosInstance.put(
    `/superadmin/question-buckets/${formData.id}`,
    formData.formData
  );
};

export const createBuckets = (formData) => {
  return axiosInstance.post("/superadmin/question-buckets", formData);
};

export const deleteBucket = (id) => {
  return axiosInstance.delete(`/superadmin/question-buckets/${id}`);
};

export const enableBuckets = (formData) => {
  return axiosInstance.put(
    `/superadmin/question-buckets/enable/${formData.id}`,
    formData.formData
  );
};

export const restrictBucket = (id) => {
  return axiosInstance.put(`/superadmin/question-buckets/restrict/${id}`);
};
